import { Box, FormGroup, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import FreeformText from './FreeformText';

export interface FreeformInfo {
  prefillValue?: string;
  questionId?: string;
  header: string;
  description: string;
  styleInfo: FreeformStyleInfo;
  selectionChangeHandler: (answer: string) => void;
}

export interface FreeformStyleInfo {
  headerStyle: {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    color: string;
    lineHeight: string;
  };
  descriptionStyle: {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    color: string;
    lineHeight: string;
  };
}

export default function FreeForm(props: FreeformInfo) {
  const { prefillValue, questionId, header, description, styleInfo, selectionChangeHandler } = props;
  const [count, setCount] = useState(0);
  const [comment, setComment] = useState(prefillValue || '');

  // DEBUG: Log component mount
  useEffect(() => {
    console.log('[FreeForm] Component mounted/remounted', {
      questionId,
      prefillValue,
      initialComment: comment,
    });
  }, []);

  // Update comment state when prefillValue changes (e.g., on back navigation)
  useEffect(() => {
    console.log('[FreeForm] prefillValue changed', {
      questionId,
      oldComment: comment,
      newPrefillValue: prefillValue,
    });
    setComment(prefillValue || '');
    setCount((prefillValue || '').length);
  }, [prefillValue]);

  function charCount(event: string) {
    setComment(event);
    setCount(event.length);
  }

  // This is executed when the state changes
  useEffect(() => {
    selectionChangeHandler(comment);
  }, [comment, count, selectionChangeHandler]); // Removed props from dependency array

  return (
    <Box sx={{ width: '100%' }}>
      <Typography gutterBottom sx={{ ...styleInfo.headerStyle, marginBottom: '1.5rem' }}>
        {header}
      </Typography>
      <Typography sx={{ ...styleInfo.descriptionStyle, marginBottom: '1.5rem' }} gutterBottom>
        {description}
      </Typography>
      <FormGroup>
        <FreeformText key={questionId} initialValue={prefillValue} textUpdate={charCount}></FreeformText>
      </FormGroup>
    </Box>
  );
}
